import React from 'react';
import ApplicationCard from "../../ApplicationCard/ApplicationCard";

type AvslåttCardProps = {
    barnNavn: string;
}

const AvslåttCard = ({ barnNavn }: AvslåttCardProps) => {
    return (
        <ApplicationCard title={barnNavn} variant={"grønn"}>
            <div className={"pkt-txt-16-light"}>
                Du har takket nei til tilbudet om barnehageplass. Ønsker du fortsatt barnehageplass, må du sende inn en ny søknad.
            </div>
        </ApplicationCard>
    );
};

export default AvslåttCard;